import { ChartSpecificColumnType, ColumnType } from '@thoughtspot/ts-chart-sdk';
import { getMNField, getMVField, isMeasureNameColumn, isMeasureValueColumn } from './helpers';
export function addMeasureNameField(queries, chartModel) {
    const mn = getMNField(chartModel.columns);
    if (!mn)
        return queries.map((q) => ({ ...q }));
    return queries.map((q) => {
        if (q.queryColumns.some(isMeasureNameColumn))
            return { ...q };
        return { ...q, queryColumns: [...q.queryColumns, mn] };
    });
}
export function addMeasureValueField(queries, chartModel) {
    const mv = getMVField(chartModel.columns);
    return queries.map((q) => {
        if (!q.queryColumns.some(isMeasureNameColumn))
            return { ...q };
        const hasMv = q.queryColumns.some(isMeasureValueColumn);
        const baseColumns = !hasMv && mv ? [...q.queryColumns, mv] : [...q.queryColumns];
        const flaggedColumns = baseColumns.map((c) => c.type === ColumnType.MEASURE ? { ...c, isMeasureValue: true } : c);
        return { ...q, queryColumns: flaggedColumns };
    });
}
export function stripMnMvFromQueries(queries) {
    return queries.map((q) => ({
        ...q,
        queryColumns: q.queryColumns
            .filter((c) => c.chartSpecificColumnType !== ChartSpecificColumnType.MEASURE_NAMES &&
            c.chartSpecificColumnType !== ChartSpecificColumnType.MEASURE_VALUES)
            .map((c) => (c.type === ColumnType.MEASURE ? { ...c, isMeasureValue: false } : c)),
    }));
}
//# sourceMappingURL=measure-name-value.js.map